import { serializerRegistrations } from './serializerRegistrations';
import { SerializerTransformer } from './SerializerTransformer';
/**
 * Flags that this property should be serialized in a format different to JSON.stringify()
 * that retains the original type. Currently supported types are:
 * - LocalDate
 * - BigNumber
 * @param typeFactory An optional function that returns the type of this property. If this parameter is not provided,
 * @param typeAlias An optional parameter that returns the original type of the property. If it is a type alias
 * the 'design:type' metadata value is used. Use this function when 'design:type' does not accurately reflect the type
 * to be serialized, e.g.: when using a union type for an optional property (Type | undefined).
 * In the case of arrays, sets and maps, typefactory is the type of the items. eg Foo[], Foo is the type, not Array
 */
export function Serialize(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
typeFactory, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
typeAlias) {
    return (target, key) => {
        const selfType = Reflect.getMetadata('design:type', target, key);
        const targetType = typeFactory ? typeFactory() : selfType;
        SerializerTransformer(key, selfType, typeAlias ? typeAlias() : undefined, targetType, serializerRegistrations)(target, key);
    };
}
